import { Serializable } from '../../common/types'
import { FlightNetworkCenterState, CenterStatus, VehicleState } from 'src/app/@store'
import { Checklist } from 'src/app/checklists'
import { Vehicle } from 'src/app/vehicles'
import { CenterEmailAddress } from './center-email-address.model'
import { MeasurementUnits } from 'src/app/common/measurement-units.model'

export class Center extends Serializable<Center> implements FlightNetworkCenterState {
  id: number | null = null
  name: string | null = null
  node_id: number | null = null
  network_id: number | null = null
  open_state: CenterStatus | null = null
  checklists: { checklist: Checklist }[] | null = null
  vehicles: Vehicle[] | null = null
  timezone: string | null = null
  email_addresses: CenterEmailAddress[] = []
  // TODO: move this member to a DeploymentsSettings object
  // so we can persist it in the BE and have it non-nullable
  measurement_units? = MeasurementUnits.metric

  constructor(details: FlightNetworkCenterState | {}) {
    super()
    this.checkAndDeserialize(details)
  }

  deserialize(details: Partial<Center>): void {
    this.id = details.id
    this.name = details.name
    this.node_id = details.node_id
    this.network_id = details.network_id
    this.open_state = details.open_state
    this.checklists = (details.checklists ?? []).map((item) => ({ checklist: new Checklist(item.checklist) }))
    this.vehicles = (details.vehicles ?? []).map((item) => new Vehicle(item))
    this.timezone = details.timezone ?? ''
    this.measurement_units = details.measurement_units
    this.email_addresses = details.email_addresses.map((item) => new CenterEmailAddress(item))
  }

  toJSON(): FlightNetworkCenterState {
    return {
      id: this.id,
      name: this.name,
      node_id: this.node_id,
      network_id: this.network_id,
      open_state: this.open_state,
      checklists: this.checklists.map((item) => ({ checklist: item.checklist.toJSON() })),
      vehicles: this.vehicles.map<VehicleState>((vehicle) => vehicle.toJSON()),
      timezone: this.timezone,
      email_addresses: this.email_addresses.map((item) => item.toJSON()),
    }
  }
}
